import { momentDateFormatter } from '#app/Util/MomentDateFormatter';

export const setStartDateFilter = (startDate: Date | string): string => {
  return momentDateFormatter.formatStartOfDay(startDate);
};

export const setEndDateFilter = (endDate: Date | string): string => {
  return momentDateFormatter.formatEndOfDay(endDate);
};
